import React, { useEffect, useState } from "react";
import { Box, Typography, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch } from "react-redux";
import { setLoading } from "../../redux/slices/apiSlice";
import {
  setOMDbContent,
  setReadContent,
  setListenContent,
} from "../../redux/slices/contentSlice/apiContent";
import CircularProgress from "@mui/material/CircularProgress";
import { setProductionCompanies } from "../../redux/slices/contentSlice/contentForm/contentForm";
import { LISTEN,WATCH,READ,DEVOTION,PLAY } from "../../constants";

const Title = ({ label, placeholder, id, formik, setCSVData }) => {
  const [contents, setContents] = useState([]);
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  console.log(options, "options");
  useEffect(() => {
    if (title) {
      searchContent();
    }
  }, [title]);

  const searchContent = async () => {
    if (!title) {
      return;
    }
    try {
      let response, data;
      if (formik.values.type === WATCH) {
        response = await fetch(
          `https://www.omdbapi.com/?apikey=bfd44542&s=${title}`
        );
        data = await response.json();
        if (data.Search) {
          // setContents([...data.Search]);
          setOptions([...data.Search]);
          setLoading(false);
        } else {
          setOptions([]);
          setLoading(false);
        }
      } else if (formik.values.type === READ) {
        setLoading(true);
        response = await fetch(
          `https://www.googleapis.com/books/v1/volumes?q=${title}&maxResults=10&projection=full`
        );
        data = await response.json();
        if (data.items) {
          setOptions(
            data.items.map((item) => {
              return {
                Title: item.volumeInfo.title,
                Year: item.volumeInfo.publishedDate,
                Author: item.volumeInfo?.authors[0],
              };
            })
          );
        } else {
          setOptions([]);
        }
        setLoading(false);
      } else if (formik.values.type === LISTEN) {
        setLoading(true);
        response = await fetch(
          `https://musicbrainz.org/ws/2/recording/?query=${title}&fmt=json&limit=10`
        );
        data = await response.json();
        if (data.recordings) {
          setOptions(
            data.recordings.map((item) => {
              return {
                Title: item.title,
                Year: item["first-release-date"],
                Artist: item["artist-credit"][0].name,
              };
            })
          );
        } else {
          setOptions([]);
        }
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  // useEffect(() => {
  //   if (title) {
  //     searchContent();
  //   }
  // }, [title]);

  useEffect(() => {
    if (formik.values.title) {
      setTitle(formik.values.title);
    } else {
      setTitle("");
    }
  }, [formik.values.title]);

  const fetchTMDBMovieID = async (value) => {
    try {
      const response = await fetch(
        `https://api.themoviedb.org/3/search/movie?query=${value}&api_key=6ef0daee795b335142f394575b3e1f02`
      );
      const tMDBData = await response.json();
      const movie = tMDBData.results.find(
        (item) => item.original_title === value
      );
      const movieID = movie.id;
      return movieID;
    } catch (error) {
      console.log("ERROR: Failed to fetch movie ID", error);
    }
  };
  const fetchTMDBTVSeriesID = async (value) => {
    try {
      const response = await fetch(
        `https://api.themoviedb.org/3/search/tv?query=${value}&api_key=6ef0daee795b335142f394575b3e1f02`
      );
      const tMDBData = await response.json();
      const tvSeries = tMDBData.results.find(
        (item) => item.original_name === value
      );
      const tvSeriesID = tvSeries.id;
      return tvSeriesID;
    } catch (error) {
      console.log("ERROR: Failed to fetch movie ID", error);
    }
  };
  const fetchTVSeriesProductionComapanies = async (seriesID) => {
    try {
      const res3 = await fetch(
        `https://api.themoviedb.org/3/tv/${seriesID}?api_key=6ef0daee795b335142f394575b3e1f02`
      );
      const tvSeriesDetails = await res3.json();

      dispatch(setProductionCompanies(tvSeriesDetails.production_companies));
      return tvSeriesDetails.production_companies;
    } catch (error) {
      console.error("Error: Failed to fetch tv production companies", error);
    }
  };

  const fetchMovieProductionCompanies = async (movieID) => {
    try {
      const res3 = await fetch(
        `https://api.themoviedb.org/3/movie/${movieID}?api_key=6ef0daee795b335142f394575b3e1f02`
      );
      const movieDetails = await res3.json();
      console.log(movieDetails.production_companies, "production_companies");
      dispatch(setProductionCompanies(movieDetails.production_companies));
      return movieDetails.production_companies;
    } catch (error) {
      console.error("Error: Failed to fetch movie production companies", error);
    }
  };

  const fetchContent = async (value) => {
    if (!value) {
      return null;
    }

    try {
      let response, data;
      if (formik.values.type === WATCH) {
        response = await fetch(
          `https://www.omdbapi.com/?apikey=bfd44542&t=${value}`
        );
        data = await response.json();
        dispatch(setOMDbContent(data));

        if (formik.values.category === "Movies") {
          const movieID = await fetchTMDBMovieID(value);
          await fetchMovieProductionCompanies(movieID);
        }
        if (formik.values.category === "TV") {
          const seriesID = await fetchTMDBTVSeriesID(value);
          await fetchTVSeriesProductionComapanies(seriesID);
        }
      } else if (formik.values.type === READ) {
        response = await fetch(
          `https://www.googleapis.com/books/v1/volumes?q=${value}&maxResults=1&projection=full`
        );
        data = await response.json();
        const volumeInfo = data.items ? data.items[0].volumeInfo : {};
        data = {
          authors: volumeInfo?.authors[0] || "",
          publisher: volumeInfo?.publisher || "",
          genre: volumeInfo?.categories || "",
          synopsis: volumeInfo?.description || "",
          year: volumeInfo?.publishedDate || "",
        };
        dispatch(setReadContent(data));
      } else if (formik.values.type === LISTEN) {
        response = await fetch(
          `https://musicbrainz.org/ws/2/recording/?query=${value}&fmt=json&limit=10`
        );
        data = await response.json();
        const recordingInfo = data.recordings ? data.recordings[0] : {};
        console.log(data, "listenData");
        data = {
          title: recordingInfo?.title || "",
          artist: recordingInfo?.["artist-credit"]?.artist || "",
          composer: recordingInfo.releases[0]["release-group"].title || "",
          year: recordingInfo["first-release-date"] || "",
          artist: recordingInfo["artist-credit"][0].artist.name,
        };
        dispatch(setListenContent(data));
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <FormControl sx={{ width: "100%" }} variant="standard">
        <label style={{ margin: "10px 0" }} htmlFor={id}>
          {label}
          <span style={{ color: "red", marginLeft: "5px" }}>*</span>
        </label>
        <Box
          component={"div"}
          sx={{
            position: "relative",
          }}
        >
          <Autocomplete
            disablePortal
            id="google-map-demo"
            fullWidth
            value={title}
            getOptionLabel={(option) => option?.Title || option}
            onInputChange={(event, newInputValue) => {
              setTitle(newInputValue);
              formik.setFieldValue("title", newInputValue);
              console.log(newInputValue, "title");
            }}
            onChange={async (event, value, reason) => {
              if (reason === "clear") {
                dispatch(setOMDbContent(null));
                dispatch(setReadContent(null));
                formik.setValues({
                  ...formik.values,
                  imdbRating: "",
                  rottenRating: "",
                  rating: "",
                  genre: [""],
                  language: "",
                  duration: 0,
                  author: "",
                  publisher: "",
                  filePath: "",
                  trailerFilePath: "",
                  synopsis: "",
                  year: "",
                  composer: "",
                  artist: "",
                  director: "",
                  actors: [""],
                  posters: [""],
                  SeasonId: "",
                  seriesId: "",
                });
                setCSVData([]);
                setOptions([]);
                return;
              }
              await fetchContent(value?.Title || value);
              formik.setFieldValue("title", value.Title);
            }}
            options={options}
            loading={loading}
            noOptionsText={"No Items Available"}
            renderOption={(props, option) => {
              const { key, ...optionProps } = props;
              return (
                <Box
                  key={key}
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...optionProps}
                >
                  {option?.Title || option} {option?.Artist} {option.Year}
                  {option?.Author}
                  <img
                    style={{ marginLeft: "auto" }}
                    src={option.Poster}
                    width={50}
                    alt=""
                  />
                </Box>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Enter  Title"
                name="title"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </Box>
      </FormControl>
      {formik.touched.title && formik.errors.title && (
        <Typography sx={{ color: "red" }}>{formik.errors.title}</Typography>
      )}
    </>
  );
};

export default Title;
